import { render, staticRenderFns } from "./dadosEContato.vue?vue&type=template&id=0b35980c&scoped=true&"
import script from "./dadosEContato.vue?vue&type=script&lang=js&"
export * from "./dadosEContato.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b35980c",
  null
  
)

export default component.exports